import type { BittsIcon } from '@crossbeam/bitts';

export const IRP_TAB = {
  overview: 'overview',
  details: 'details',
  contacts: 'contacts',
  opportunities: 'opportunities',
  timeline: 'timeline',
} as const;

export type IRPTabType = (typeof IRP_TAB)[keyof typeof IRP_TAB];

export const IRP_TAB_ROUTES: Record<IRPTabType, string> = {
  [IRP_TAB.overview]: 'individual_record_overview',
  [IRP_TAB.details]: 'individual_record_details',
  [IRP_TAB.contacts]: 'individual_record_contacts',
  [IRP_TAB.opportunities]: 'individual_record_opportunities',
  [IRP_TAB.timeline]: 'activity_timeline',
};

export const IRP_TAB_SCOPES: Partial<Record<IRPTabType, string>> = {
  [IRP_TAB.timeline]: 'read:activity-timeline',
};

export const IRP_TABS: { name: string; value: IRPTabType; icon: BittsIcon }[] =
  [
    { name: 'Overview', value: IRP_TAB.overview, icon: ['fak', 'company'] },
    {
      name: 'Account Details',
      value: IRP_TAB.details,
      icon: ['fak', 'opportunity'],
    },
    { name: 'Contacts', value: IRP_TAB.contacts, icon: ['fak', 'contacts'] },
    {
      name: 'Opportunities',
      value: IRP_TAB.opportunities,
      icon: ['fak', 'opportunity'],
    },
    { name: 'Activity', value: IRP_TAB.timeline, icon: ['fak', 'time'] },
  ];

/**
 * ARR and Segment have no MDM property, so the header matches them against the
 * own master record's field names. Pending the field contract in PEX-491.
 * @see https://linear.app/xbeam/issue/PEX-491/irp-overview-tech-plan (2026-09-08)
 */
export const HEADER_ARR_FIELD_NAMES = ['arr', 'annual recurring revenue'];

export const HEADER_SEGMENT_FIELD_NAMES = [
  'segment',
  'account segment',
  'customer segment',
];
